import "./index.css";
import "./components/NavBar.css";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import App from "./App";
import registerServiceWorker, { unregister } from "./registerServiceWorker";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { SnackbarProvider } from "notistack";
import Cookies from "js-cookie";
import { config } from "./helpers/config";
import { getLoggedUser, handleResponse, handleError } from "./helpers";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById("root");
const themee = createMuiTheme({
	palette: {
		primary: {
			main: "#760e26",
			light: "#bbbbbb"
		},
		secondary: {
			main: "#cccccc"
		}
	},
	typography: {
		fontFamily: ["Open Sans", "sans-serif"].join(",")
	}
});

const render = function() {
	return ReactDOM.render(
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<MuiThemeProvider theme={themee}>
					<CssBaseline />
					<SnackbarProvider
						anchorOrigin={{
							vertical: "top",
							horizontal: "right"
						}}>
						<App />
					</SnackbarProvider>
				</MuiThemeProvider>
			</ConnectedRouter>
		</Provider>,
		rootElement
	);
};

// check for student remote credentials:
const loggedUser = getLoggedUser();

if (!loggedUser) {
	var unwesauth = Cookies.get("unwesauth");
	if (unwesauth !== undefined) {
		fetch(`/api/authentication/remote`, {
			method: "POST"
		})
			.then(handleResponse)
			.then(
				loggedUser => {
					if (loggedUser && loggedUser.id) {
						localStorage.setItem(
							"loggedUser",
							JSON.stringify(loggedUser)
						);
						return loggedUser;
					}
				},
				error => {
					render();
				}
			)
			.then(() => render());
	} else render();
} else render();

unregister();
